import React, { useState, useEffect } from "react";
import Welcome from "../images/welcome.svg";
// import ez from "../images/ez.svg";
// import doves from "../images/doves.svg";
import "../styles/main.scss";
import { Helmet } from "react-helmet";
import "../styles/main.scss";
import "../styles/hero.scss";

const PASSWORD = "savannah2027"; // change this

export default function Password({ children }) {
  const [authorized, setAuthorized] = useState(false);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authorized) {
      window.scrollTo(0, 0);
    }
  }, [authorized]);

  useEffect(() => {
    const stored = localStorage.getItem("access_granted");
    if (stored === "true") setAuthorized(true);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!authorized) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }

    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, [authorized]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim().toLowerCase() === PASSWORD) {
      localStorage.setItem("access_granted", "true");
      setAuthorized(true);
    } else {
      alert("Wrong password");
    }
  };

  if (loading) return null;

  if (authorized) return children;

  return (
    <div>
      <Helmet>
        <title>Welcome | Zoey & Eric</title>
        <meta name="description" content="password page" />
      </Helmet>
      {/* <img className={"doves"} src={doves} alt="doves" /> */}
      <div className={"welcome"} style={styles.wrapper}>
        <img className={"welcome-script"} src={Welcome} alt="welcome" />
        <h2>
          We can't wait to celebra<span>t</span>e <br></br>with you!
        </h2>
        <div>
          <h2 style={{ marginBottom: "16px", marginTop: "24px" }}>
            Please enter the password:
          </h2>
          <form onSubmit={handleSubmit} style={styles.form}>
            <input
              type="password"
              placeholder=""
              value={input}
              onChange={(e) => setInput(e.target.value)}
              style={styles.input}
            />
            <button
              className={"button-arrow"}
              type="submit"
              style={styles.button}
            >
              →
            </button>
          </form>
          {/* <img className={"ez"} src={ez} alt="ez" /> */}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    height: "100vh",
    background: "#bbcbe8",
  },
  form: {
    display: "flex",
    // flexDirection: "column",
    gap: "10px",
    justifyContent: "center",
  },
  input: {
    padding: "10px",
    fontSize: "16px",
    backgroundColor: "#ffe5c3",
    border: "none",
    borderRadius: "40px",
    width: "50vw",
  },
  button: {
    padding: "10px",
    backgroundColor: "#ffe5c3",
    cursor: "pointer",
    border: "none",
    borderRadius: "50%",
    borderColor: "black",
    height: "40px",
    width: "40px",
    fontWeight: "bold",
    textAlign: "center",
  },
};
